<template>
  <button class="btn" :style="{ background: color }" @click="onClick()">{{ text }}</button>
</template>

<script>
export default {
  name: 'TaskButton',
  props: {
    text: String,
    color: String,
  },
  methods: {
    onClick() {
      console.log('click')
    }
  }
}
</script>
